import { supabase } from '@/core/database/supabase';
import type { ConstructionBoqItem, BoqStats } from '../types/construction-boq.types';

export const ConstructionBoqItemsService = {
  async getBoqItems(boqId: string) {
    const { data, error } = await supabase
      .from('construction_boq_items')
      .select(`
        *,
        zone:project_zones(id, name),
        phase:project_phases(id, name)
      `)
      .eq('boq_id', boqId)
      .order('sort_order', { ascending: true });

    if (error) throw error;
    return data as ConstructionBoqItem[];
  },

  async getBoqStats(boqId: string): Promise<BoqStats> {
    const { data, error } = await supabase
      .from('construction_boq_items')
      .select('total_amount, material_cost, labor_cost, equipment_cost')
      .eq('boq_id', boqId);

    if (error) throw error;

    const totalAmount = data.reduce((sum, item) => sum + item.total_amount, 0);
    const material = data.reduce((sum, item) => sum + item.material_cost, 0);
    const labor = data.reduce((sum, item) => sum + item.labor_cost, 0);
    const equipment = data.reduce((sum, item) => sum + item.equipment_cost, 0);

    return {
      totalAmount,
      itemCount: data.length,
      materialShare: totalAmount > 0 ? (material / totalAmount) * 100 : 0,
      laborShare: totalAmount > 0 ? (labor / totalAmount) * 100 : 0,
      equipmentShare: totalAmount > 0 ? (equipment / totalAmount) * 100 : 0,
    };
  },

  async createBoqItem(data: Partial<ConstructionBoqItem>) {
    const { data: result, error } = await supabase
      .from('construction_boq_items')
      .insert([data])
      .select()
      .single();

    if (error) throw error;
    return result as ConstructionBoqItem;
  },

  async updateBoqItem(id: string, updates: Partial<ConstructionBoqItem>) {
    const { error } = await supabase
      .from('construction_boq_items')
      .update(updates)
      .eq('id', id);

    if (error) throw error;
  },

  async deleteBoqItem(id: string) {
    const { error } = await supabase
      .from('construction_boq_items')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }
};
